// Copyright (c) 2020-2024 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
// import { SvgIconProps } from '@material-ui/core/SvgIcon';
import { SvgIconProps } from '@mui/material';

import LogoSmall from './Small';
// import LogoBig from './Big';
import BigLogoPng from './BigLogoPng';

interface LogoProps extends SvgIconProps { 
  small?: boolean;
}

// Show the expand/collapse VI logo.
const Logo: React.FC<LogoProps> = ({ small, ...otherProps}) => {
  //return small ? <LogoSmall {...otherProps} /> : <LogoBig {...otherProps} />;
  return small ? <LogoSmall {...otherProps} /> : <BigLogoPng {...otherProps} />;
};

export default Logo;